<script setup lang="ts">
const el = ref()
const v = useElementVisibility(el)
</script>

<template>
  <div class="section-2" pb-80px text-center lg:pb-180px>
    <p text-14px animated animated-fade-in-up>
      A Milestone in Pageantry<br>
      First ever historic 1499 BTC grand prize.<br>
      Valued at Millions!<br>
      Transforming the winner's future overnight.<br>
      Be part of the Revolution!<br>
      Largest prize in beauty pageant history awaits
    </p>

    <a href="https://missweb3.app" target="_blank" mt-40px class="mx-auto btn-primary w-295px rounded-12px p-[20px_24px] uppercase">
      VOTE NOW
    </a>

    <div ref="el" relative mt-80px sm="max-w-500px mx-auto rounded-20px overflow-hidden">
      <img w-full object-cover src="/images/image-1478-m.webp" alt="">

      <div class="mask" absolute inset-0 />

      <div absolute inset-x-0 top-110px px-12px text-center animated :class="[v && ['animated-fade-in-up']]">
        <p text-40px font-700 class="lh-100%">
          PRIZE WALLET
        </p>

        <p mt-27px text-14px font-bold class="lh-100%">
          1Lafcr4sA********************AbX71
        </p>

        <p class="lh-100%" mt-10px text-14px>
          Crypto Wallet with 1499 BTC will be shown during Event Day.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>
.mask {
  background: linear-gradient(
    180deg,
    rgba(128, 0, 14, 0.7) 0%,
    rgba(102, 0, 0, 0) 17.48%,
    rgba(95, 0, 0, 0) 63.36%,
    #000 93.55%
  );
}
</style>
